export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  chapters: number;
  updateDate: string;
  rating: number;
  views: number;
  status: string;
  tags: string[];
  featured: boolean;
  latestChapter: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '社内恋爱法则',
    author: '金智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20manhwa%20cover%20illustration%2C%20romance%20office%20drama%2C%20beautiful%20young%20couple%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20clean%20lineart%2C%20pastel%20color%20palette%2C%20emotional%20expression%2C%20professional%20webtoon%20art%20style%2C%20Korean%20manhwa%20aesthetic&width=800&height=1100&seq=comic-01&orientation=portrait',
    description: '在首尔最顶尖的广告公司里，新人设计师林夏妍意外发现自己的上司竟然是大学时期的暗恋对象。办公室恋情、职场竞争、创意火花，一场甜蜜又刺激的社内恋爱就此展开。',
    category: '恋爱',
    categorySlug: 'romance',
    chapters: 86,
    updateDate: '2026-08-04',
    rating: 9.2,
    views: 1280000,
    status: '连载中',
    tags: ['职场', '甜宠', '办公室恋情'],
    featured: true,
    latestChapter: '第86话 - 告白之夜',
  },
  {
    id: 2,
    title: '暗黑剑圣',
    author: '朴在东',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20action%20manhwa%20cover%2C%20dark%20fantasy%20warrior%20with%20glowing%20sword%2C%20epic%20battle%20scene%2C%20dramatic%20lighting%2C%20intense%20atmosphere%2C%20detailed%20armor%20design%2C%20professional%20webtoon%20art%20style&width=800&height=1100&seq=comic-02&orientation=portrait',
    description: '曾经被誉为大陆最强剑圣的卡尔，在背叛中陨落。十年后他以暗黑之力重生，踏上了复仇与救赎之路。剑与魔法的史诗级战斗画卷就此展开。',
    category: '动作',
    categorySlug: 'action',
    chapters: 124,
    updateDate: '2026-08-04',
    rating: 9.5,
    views: 2150000,
    status: '连载中',
    tags: ['奇幻', '战斗', '复仇'],
    featured: true,
    latestChapter: '第124话 - 终焉之剑',
  },
  {
    id: 3,
    title: '异世界便利店',
    author: '李秀贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20comedy%20manhwa%20cover%2C%20magical%20convenience%20store%20in%20fantasy%20world%2C%20cute%20character%20design%2C%20colorful%20and%20bright%20atmosphere%2C%20whimsical%20fantasy%20elements%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-03&orientation=portrait',
    description: '普通大学生金泰浩一觉醒来发现自己穿越到了剑与魔法的异世界——但他开的不是冒险者公会，而是一家便利店！泡面、饭团、咖啡征服异世界居民的胃，搞笑的异世界日常就此开始。',
    category: '奇幻',
    categorySlug: 'fantasy',
    chapters: 72,
    updateDate: '2026-08-03',
    rating: 8.9,
    views: 980000,
    status: '连载中',
    tags: ['穿越', '日常', '美食'],
    featured: true,
    latestChapter: '第72话 - 异世界炸鸡大战',
  },
  {
    id: 4,
    title: '校霸的秘密',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20school%20romance%20manhwa%20cover%2C%20handsome%20male%20student%20with%20mysterious%20expression%2C%20campus%20background%2C%20cherry%20blossom%2C%20soft%20romantic%20atmosphere%2C%20professional%20webtoon%20art%20style&width=800&height=1100&seq=comic-04&orientation=portrait',
    description: '全校闻名的冷酷校霸姜智勋，私下却是个喜欢看恋爱漫画的宅男。当这个秘密被转学生沈恩智发现后，两人的关系发生了微妙的变化。高冷校霸的真面目究竟是什么样的？',
    category: '恋爱',
    categorySlug: 'romance',
    chapters: 56,
    updateDate: '2026-08-02',
    rating: 9.0,
    views: 1560000,
    status: '连载中',
    tags: ['校园', '反差萌', '甜宠'],
    featured: false,
    latestChapter: '第56话 - 无法隐藏的真心',
  },
  {
    id: 5,
    title: '末日生存指南',
    author: '崔正宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20thriller%20manhwa%20cover%2C%20post%20apocalyptic%20survival%20scene%2C%20dark%20and%20tense%20atmosphere%2C%20survivors%20in%20ruined%20city%2C%20dramatic%20composition%2C%20professional%20webtoon%20art%20style&width=800&height=1100&seq=comic-05&orientation=portrait',
    description: '不明病毒席卷全球，首尔沦为一座死城。普通上班族韩道允必须在丧尸横行的末日世界中找到生存之道。人性、生存、希望，在这个残酷的世界里，什么才是最重要的？',
    category: '悬疑',
    categorySlug: 'thriller',
    chapters: 94,
    updateDate: '2026-08-03',
    rating: 9.3,
    views: 1890000,
    status: '连载中',
    tags: ['丧尸', '生存', '心理'],
    featured: true,
    latestChapter: '第94话 - 最后的避难所',
  },
  {
    id: 6,
    title: '猫咪咖啡馆',
    author: '尹美京',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20healing%20manhwa%20cover%2C%20cozy%20cat%20cafe%20interior%2C%20cute%20cats%20and%20warm%20atmosphere%2C%20soft%20pastel%20colors%2C%20gentle%20healing%20vibe%2C%20professional%20webtoon%20art%20style&width=800&height=1100&seq=comic-06&orientation=portrait',
    description: '在大城市里疲惫不堪的女孩秀雅，偶然走进了一家小小的猫咪咖啡馆。在这里她遇到了六只性格各异的猫咪和温柔的店长。一杯咖啡、一只猫、一段治愈的时光。',
    category: '治愈',
    categorySlug: 'healing',
    chapters: 48,
    updateDate: '2026-08-01',
    rating: 9.1,
    views: 720000,
    status: '已完结',
    tags: ['日常', '温馨', '猫咪'],
    featured: false,
    latestChapter: '第48话 - 新的开始（完结）',
  },
  {
    id: 7,
    title: '爆笑体育课',
    author: '张民浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20comedy%20manhwa%20cover%2C%20funny%20school%20sports%20scene%2C%20exaggerated%20expressions%2C%20dynamic%20action%2C%20bright%20and%20lively%20colors%2C%20humorous%20character%20design%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-07&orientation=portrait',
    description: '一所奇葩的高中里，体育课变成了各种匪夷所思的竞技场。从躲避球到枕头大战，从食堂抢饭到考试生存战，这群高中生的体育课永远充满了笑料和意外。',
    category: '搞笑',
    categorySlug: 'comedy',
    chapters: 108,
    updateDate: '2026-08-04',
    rating: 8.7,
    views: 860000,
    status: '连载中',
    tags: ['校园', '日常', '欢乐'],
    featured: false,
    latestChapter: '第108话 - 年度躲避球大赛',
  },
  {
    id: 8,
    title: '逆袭之星途',
    author: '宋智雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20drama%20manhwa%20cover%2C%20glamorous%20entertainment%20industry%20setting%2C%20beautiful%20actress%20on%20stage%2C%20spotlight%20and%20glamour%2C%20professional%20webtoon%20art%20style&width=800&height=1100&seq=comic-08&orientation=portrait',
    description: '从小配角到影后，韩素拉的逆袭之路充满了泪水与汗水。娱乐圈的明争暗斗、真挚的友情与爱情，一个普通女孩如何在残酷的演艺圈中绽放光芒？',
    category: '剧情',
    categorySlug: 'drama',
    chapters: 134,
    updateDate: '2026-08-03',
    rating: 9.4,
    views: 2010000,
    status: '连载中',
    tags: ['娱乐圈', '励志', '成长'],
    featured: true,
    latestChapter: '第134话 - 最佳女主角',
  },
  {
    id: 9,
    title: '月光下的约定',
    author: '金允儿',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20fantasy%20manhwa%20cover%2C%20moonlit%20night%20scene%20with%20beautiful%20couple%2C%20magical%20atmosphere%2C%20traditional%20Korean%20elements%2C%20ethereal%20lighting%2C%20romantic%20mood%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-09&orientation=portrait',
    description: '朝鲜时代的贵族小姐与来自现代的时空旅人相遇在月光之下。跨越三百年的爱恋，两个不同时代的人能否打破命运的枷锁？',
    category: '恋爱',
    categorySlug: 'romance',
    chapters: 62,
    updateDate: '2026-08-03',
    rating: 9.6,
    views: 1750000,
    status: '已完结',
    tags: ['穿越', '古装', '虐恋'],
    featured: false,
    latestChapter: '第62话 - 永恒之约（完结）',
  },
  {
    id: 10,
    title: '武道巅峰',
    author: '权相宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20martial%20arts%20action%20manhwa%20cover%2C%20powerful%20fighter%20in%20dynamic%20pose%2C%20martial%20arts%20tournament%2C%20intense%20energy%20effects%2C%20dramatic%20composition%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-10&orientation=portrait',
    description: '武道世家出身的韩镇宇，从小被认为没有武学天赋而遭家族遗弃。十年后他以神秘武学归来，横扫各大武道大会，向整个武道界证明——天赋不是一切！',
    category: '动作',
    categorySlug: 'action',
    chapters: 156,
    updateDate: '2026-08-04',
    rating: 9.1,
    views: 1670000,
    status: '连载中',
    tags: ['武术', '热血', '逆袭'],
    featured: false,
    latestChapter: '第156话 - 巅峰对决',
  },
  {
    id: 11,
    title: '魔法学院特招生',
    author: '林恩智',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20magic%20academy%20fantasy%20manhwa%20cover%2C%20magical%20school%20setting%2C%20students%20casting%20spells%2C%20colorful%20magic%20effects%2C%20whimsical%20atmosphere%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-11&orientation=portrait',
    description: '出身平民的朴瑞俊意外获得了魔法学院的入学资格。在这个贵族云集的魔法世界里，他用独特的魔法理解和创新的施法方式，打破阶层壁垒，成为学院史上最传奇的特招生。',
    category: '奇幻',
    categorySlug: 'fantasy',
    chapters: 98,
    updateDate: '2026-08-02',
    rating: 9.0,
    views: 1120000,
    status: '连载中',
    tags: ['学院', '魔法', '成长'],
    featured: false,
    latestChapter: '第98话 - 终极试炼',
  },
  {
    id: 12,
    title: '深夜食堂：韩屋篇',
    author: '赵恩秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20food%20healing%20manhwa%20cover%2C%20warm%20traditional%20Korean%20restaurant%20at%20night%2C%20delicious%20Korean%20food%2C%20cozy%20atmosphere%2C%20soft%20lighting%2C%20heartwarming%20vibe%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-12&orientation=portrait',
    description: '隐藏在首尔小巷深处的一家深夜食堂，只在午夜开门。每一道菜背后都藏着一段故事，每一位客人都在寻找属于自己的温暖。用美食治愈每一个疲惫的灵魂。',
    category: '治愈',
    categorySlug: 'healing',
    chapters: 42,
    updateDate: '2026-07-30',
    rating: 9.3,
    views: 640000,
    status: '连载中',
    tags: ['美食', '温馨', '人生'],
    featured: false,
    latestChapter: '第42话 - 妈妈的泡菜汤',
  },
  {
    id: 13,
    title: '推理游戏',
    author: '安宰贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20mystery%20thriller%20manhwa%20cover%2C%20detective%20investigation%20scene%2C%20dark%20mysterious%20atmosphere%2C%20clues%20and%20evidence%2C%20tense%20mood%2C%20professional%20webtoon%20art%20style&width=800&height=1100&seq=comic-13&orientation=portrait',
    description: '天才侦探李贤宰收到一封神秘邀请函，被卷入了一场致命的推理游戏。六个参赛者、七道谜题、一个隐藏在城市中的真相。每一步推理都可能是最后一步……',
    category: '悬疑',
    categorySlug: 'thriller',
    chapters: 36,
    updateDate: '2026-08-04',
    rating: 9.4,
    views: 890000,
    status: '连载中',
    tags: ['推理', '犯罪', '烧脑'],
    featured: false,
    latestChapter: '第36话 - 第六道谜题',
  },
  {
    id: 14,
    title: '家族荣耀',
    author: '郑海镇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20family%20drama%20manhwa%20cover%2C%20wealthy%20Korean%20family%20portrait%2C%20traditional%20hanok%20mansion%2C%20dramatic%20tension%2C%20elegant%20and%20serious%20atmosphere%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-14&orientation=portrait',
    description: '韩国最大财阀家族的内斗大戏。二公子郑宇贤在家族权力斗争中步步为营，从被排挤的边缘人到掌控全局的掌舵者，书写了一段商战传奇。',
    category: '剧情',
    categorySlug: 'drama',
    chapters: 118,
    updateDate: '2026-08-02',
    rating: 9.2,
    views: 1430000,
    status: '连载中',
    tags: ['家族', '商战', '权谋'],
    featured: false,
    latestChapter: '第118话 - 继承人',
  },
  {
    id: 15,
    title: '我成了反派的妹妹',
    author: '南珠贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20comedy%20fantasy%20manhwa%20cover%2C%20funny%20isekai%20reincarnation%20theme%2C%20cute%20female%20lead%20with%20villain%20brother%2C%20bright%20colorful%20palette%2C%20humorous%20expression%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-15&orientation=portrait',
    description: '读完一本烂尾小说后，沈敏雅意外穿越进了书中的世界——而且还成了最终大反派的妹妹！为了让哥哥和全家避免毁灭结局，她开始了爆笑的"反派改造计划"。',
    category: '搞笑',
    categorySlug: 'comedy',
    chapters: 68,
    updateDate: '2026-08-03',
    rating: 8.8,
    views: 920000,
    status: '连载中',
    tags: ['穿越', '恶役', '兄妹'],
    featured: false,
    latestChapter: '第68话 - 哥哥的第一次约会',
  },
  {
    id: 16,
    title: '海之女神',
    author: '吴彩琳',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20romance%20manhwa%20cover%2C%20mermaid%20goddess%20in%20underwater%20palace%2C%20beautiful%20ocean%20scenery%2C%20ethereal%20lighting%2C%20magical%20atmosphere%2C%20elegant%20and%20mysterious%2C%20professional%20webtoon%20art&width=800&height=1100&seq=comic-16&orientation=portrait',
    description: '深海国度的人鱼公主海琳娜，为了寻找失踪的母后而来到人类世界。在这里她遇到了海洋学家韩志浩，一段人类与人鱼之间跨越种族的浪漫传奇由此开始。',
    category: '奇幻',
    categorySlug: 'fantasy',
    chapters: 54,
    updateDate: '2026-08-01',
    rating: 9.1,
    views: 780000,
    status: '连载中',
    tags: ['人鱼', '海洋', '奇幻爱情'],
    featured: false,
    latestChapter: '第54话 - 深海之秘',
  },
];

export const featuredComics = comics.filter((c) => c.featured);
export const latestComics = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());
export const popularComics = [...comics].sort((a, b) => b.views - a.views);
export const topRatedComics = [...comics].sort((a, b) => b.rating - a.rating);

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
}